import React, { useState } from 'react';
import { Row, Label, Input } from "reactstrap"


const DPTextBoxforCreditNote = ({ rowClass, labelText, textType, value, onChange, placeholder, defaultValue, textAlign, maxLength, width, id, disabled, onBlur, fontSize, onKeyPress, val1, val2 }) => {
    return (
        <Row className={rowClass}>
            <div className="col-md-12">
                <Input
                    className="form-control-sm"
                    type={textType}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    defaultValue={defaultValue}
                    style={{ textAlign: textAlign ? textAlign : 'left', fontSize: fontSize, color: 'Black', background: val1 && val2 != undefined ? parseFloat(val1) > parseFloat(val2) ? '#f49494' : '' : '' }}
                    maxLength={maxLength}
                    width={width}
                    id={id}
                    disabled={disabled}
                    onBlur={onBlur}
                    onKeyPress={onKeyPress}

                />
            </div>
        </Row>
    );
}

export default DPTextBoxforCreditNote;